//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BindsAttrs, Sizeable } from '@/mixins'

export default {
  mixins: [ BindsAttrs, Sizeable ],
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    i18nKey: {
      type: String,
      default: '',
      required: false,
    },
    /**
     * The data to be passed to the i18n translations
     */
    i18nData: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      open: false,
      resolve: null,
      reject: null,
      title: null,
      confirmAction: null,
      zIndex: 200,
      color: '#ffffff',
      loading: {
        agree: false
      }
    }
  },
  computed: {
    hasNoSlot () {
      return this.$slots.no || this.$te('confirm.' + this.i18nKey + '.no')
    },
    hasHeaderSlot () {
      return this.$slots.header || this.$te('confirm.' + this.i18nKey + '.header')
    },
    hasBodySlot () {
      return this.$slots.body || this.$te('confirm.' + this.i18nKey + '.body')
    },
    maxWidth () {
      if (this.small) {
        return 475
      }
      if (this.large) {
        return 579
      }
      return 548
    },
  },
  methods: {
    confirm (confirmAction = () => true) {
      this.open = true
      this.confirmAction = confirmAction
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async handleYes () {
      if (this.disabled) {
        return
      }
      if (this.confirmAction !== null) {
        this.loading.agree = true
        try {
          if ((await this.confirmAction()) === false) {
            return false
          }
          this.resolve(true)
        } catch (e) {
          this.$errorHandler.handle(e)
          this.resolve(false)
        } finally {
          this.loading.agree = false
        }
      } else {
        this.resolve(true)
      }
      this.open = false
    },
    /**
     *  This method handles top right close button, it will close the modal
     */
    close () {
      this.resolve(null)
      this.open = false
    },
    /**
     * This method handles bottom right side button, resolves promise false
     */
    handleNo () {
      this.resolve(false)
      this.open = false
    }
  }
}
